import { RequestModel } from "model";

import { SchoolItem, SubItem } from "./Waitlist.page";

// Unique array of all subs in all pools in the waitlist req index

export const subReducer = (accumulator: SubItem[], request: RequestModel) => {
  for (const user of request.pool) {
    const newItem = { id: user.id, name: user.name, photo: user.photo, signedUpRequests: 1 };
    // Check if sub already exists in accumulator array
    //
    // If not, adds it to the array.
    // If it exists, add one to the count of the existing element in the array.
    if (!accumulator.some((s) => s.id === newItem.id)) {
      accumulator.push(newItem);
    } else {
      const idx = accumulator.findIndex((s) => s.id === newItem.id);
      accumulator[idx].signedUpRequests += 1;
    }
  }
  return accumulator;
};

// Unique array of all schools in the waitlist req index

export const schoolReducer = (accumulator: SchoolItem[], request: RequestModel) => {
  const newItem = { id: request.school.id, name: request.school.name, waitlistedRequests: 1 };
  // Check if school already exists in accumulator array
  //
  // If not, adds it to the array.
  // If it exists, add one to the count of the existing element in the array.

  if (!accumulator.some((s) => s.id === newItem.id)) {
    accumulator.push(newItem);
  } else {
    const idx = accumulator.findIndex((s) => s.id === newItem.id);
    accumulator[idx].waitlistedRequests += 1;
  }
  return accumulator;
};
